import type { FC } from 'react'

export const TokenApproveButton: FC = () => {
  return <></>
}
